module.exports = __webpack_public_path__ + "static/2017_PAYG_Withholding_Tax_Variation_Checklist-070d286b9069eac488e31df8c7ec6ede.pdf";